import * as React from 'react';
import { Text } from '@televet/kibble-ui/build/components/Text';

interface AutomationsFieldDescriptionProps {
  children: React.ReactNode;
}

export const AutomationsFieldDescription = ({ children }: AutomationsFieldDescriptionProps): JSX.Element => {
  return (
    <Text as="p" mt={2} mb={4} variant="subtle" className="Automations__FieldDescription">
      {children}
    </Text>
  );
};
